module.exports = __webpack_public_path__ + "img/signsealer.f7fa41af.svg";